import React from 'react';
import { styled } from '@mui/material/styles';
import paymentMethodImg from './payment_methods.png';

const StyledImage = styled('img')(() => ({
  display: 'block',
  margin: 'auto',
  marginTop: 2,
}));

interface Props {
  children: React.ReactNode;
}

export const PaymentMethodWrapper = ({ children }: Props) => {
  return (
    <div>
      {children}
      <StyledImage src={paymentMethodImg} alt={''} />
    </div>
  );
};
